import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectors } from "reducers";
import { fetchSynthpopCallLogMetrics } from "actions/synthpop-call-logs";
import { SumBlock, Waiting } from "components/ui";
import OutcomeChart from "./outcome-chart";
import AnsweredByChart from "./answered-by-chart";
import DispositionChart from "./disposition-chart";
import ConnectionChart from "./connection-chart";
import TaskTypeChart from "./task-type-chart";
import moment from "moment";

const SynthpopMetrics = ({ startDate, endDate, companyGuid }) => {
  const dispatch = useDispatch();
  const metrics = useSelector(selectors.getSynthpopMetrics);
  const isFetching = useSelector(selectors.getIsFetchingSynthpopMetrics);

  useEffect(() => {
    // Convert MM/DD/YYYY to ISO format for API
    const isoStart = moment(startDate, "MM/DD/YYYY").format("YYYY-MM-DD");
    const isoEnd = moment(endDate, "MM/DD/YYYY").format("YYYY-MM-DD");
    dispatch(fetchSynthpopCallLogMetrics(isoStart, isoEnd, companyGuid));
  }, [startDate, endDate, companyGuid, dispatch]);

  if (isFetching) return <Waiting reason="Loading AI call metrics..." />;
  if (!metrics) return <div style={{ padding: "20px" }}>No metrics data available.</div>;

  return (
    <div className="agent-calling-metrics">
      <div className="metrics-summary-blocks">
        <SumBlock
          title="Total Calls"
          value={metrics.totalCalls}
          subLabel={`Secondary: ${metrics.secondaryAttempts || 0}`}
        />
        <SumBlock
          title="Orders Created"
          value={metrics.ordersCreated}
          subLabel={`Conversion: ${metrics.conversionRate || 0}%`}
        />
        <SumBlock
          title="Transferred to S3"
          value={metrics.transferredToHuman}
        />
        <SumBlock
          title="Needs Attention"
          value={metrics.needsAttention}
        />
        <SumBlock
          title="Errors"
          value={metrics.errors}
          subLabel={`Error Rate: ${metrics.errorRate || 0}%`}
        />
        <SumBlock
          title="Tasks Created"
          value={metrics.totalTasksCreated}
        />
      </div>
      <div className="graph-row">
        <ConnectionChart
          connectedToAI={metrics.connectedToAI}
          notConnectedToAI={metrics.notConnectedToAI}
          connectionRate={metrics.connectionRate}
        />
        <AnsweredByChart answeredByBreakdown={metrics.answeredByBreakdown} />
      </div>
      <div className="graph-row">
        <OutcomeChart outcomeBreakdown={metrics.outcomeBreakdown} />
        <DispositionChart dispositionBreakdown={metrics.dispositionBreakdown} />
      </div>
      <div className="graph-row">
        <TaskTypeChart taskTypeBreakdown={metrics.taskTypeBreakdown} />
      </div>
    </div>
  );
};

export default SynthpopMetrics;
